<template>
  <div :class="{[`device-${getPlatform()}`]:true}">
    <div class="dali-progress-wrapper">
      <DaliProgressV3 ref="DaliProgressV3" :currentProcessCode="currentProcessCode"
                      :processGraphic="processGraphic" v-if="processGraphic"
                      @chooseAbility="handleChooseAbility" @finish="removeLister"
                      @changeFinish="changeFinish" :programId="programId"></DaliProgressV3>
    </div>
    <div style="position: relative">
      <div style="position: fixed;z-index: 66666;left: 0;right: 0;top:0;bottom: 0;background: rgba(0,0,0,0.3)" v-if="maskLoading">
        <a-spin :spinning="true" tip="生成中..." style="width: 100%;height: 100%">
          <div style="width: 100%;height: 100vh;"></div>
        </a-spin>
      </div>
      <DataUploadedModal ref="dataUploadedModalRef" @unlock="handleDataUploadedModalUnlock"></DataUploadedModal>
      <div v-if="currentProcessCode=='upload'">
        <div v-if="getPlatform()=='pc'" style="margin-top: 16px">
          <a-tabs :default-active-key="processGraphic?.graphicItemMap?.upload.children[0].code"  >
            <a-tab-pane :key="item.code" :tab="item.name"
                        v-for="item in processGraphic?.graphicItemMap.upload.children">
              <template v-if="item.code=='TaxUpload'||item.code=='InvoiceUpload'">
                <!--上传数据-->
                <RemoteComponent
                  ref="fetchRemoteComponentRef"
                  :base="microServiceVue2"
                  show-loadingservice="bankDataUploader"
                  :src="`manual-table-list/${ reportId }?ability=${item.code}&token=${ token }`"
                  type="iframe"
                  :style="{height:'calc(100vh - 111px)',minHeight:'auto'}"
                  @doneOrPass="doneOrPass"
                  @vueRouterChange="handleFetchRemoteComponentRefVueRouterChange"
                >
                </RemoteComponent>
                <!--/上传数据-->
                <div class="create-report-btn" v-show="showCreateBtn">

                <a-button type="primary" :loading="creating" style="width:160px"
                          @click="createReport">生成报告
                </a-button>
                </div>
              </template>
              <template v-else>

                <handleFinalSettlement :programId="programId" @doneOrPass="doneOrPass"
                                       :data="item" :reportId="reportId"></handleFinalSettlement>



              </template>
            </a-tab-pane>
          </a-tabs>
        </div>
        <MobileUploaderTip v-else-if="getPlatform()=='mobile'"></MobileUploaderTip>
      </div>
      <div v-else-if="currentProcessCode=='data_authorize'">

        <div v-if="this.processGraphic?.graphicItemMap?.data_authorize?.nodeStatus==1">
          <div class="topselect">
            <div @click="changeType(1)" :class="index == 1 ? 'active' : ''">
              账密授权
            </div>
            <div @click="changeType(3)" :class="index == 3 ? 'active' : ''">
              扫码授权
            </div>
            <div
              v-if="canShowAuthProxy"
              @click="changeType(2)"
              :class="index == 2 ? 'active' : ''"
            >
              代理授权
            </div>
          </div>
          <div>


            <left
                  :disableCompanyChange="true"
                  :enable-invitation="true"
                  :show-license-agreement="canShowAuthLicenseAgreement"
                  :show-invitation="canShowAuthInvitation"
                  v-if="index == 1"
                  :info="companyInfo" :aName="appTypeName" :jzm="validateMethod" :pId="programId"
                  :icd="isChecked" :idm="isDemo" @success="handleLeftSuccess" :type="2"></left>
            <right v-if="canShowAuthProxy && index == 2" :info="companyInfo" :aName="appTypeName" :jzm="validateMethod"
                   :pId="programId" :icd="isChecked" :idm="isDemo" :type="2"></right>
            <QrAuthorize
              from="2rd"
              :disableCompanyChange="true"
              :show-license-agreement="canShowAuthLicenseAgreement"
              :show-invitation="canShowAuthInvitation"
              @success="handleLeftSuccess"
              v-if="index == 3"
              :info="companyInfo"
              :aName="appTypeName"
              :jzm="validateMethod"
              :pId="programId"
              :icd="isChecked"
              :idm="isDemo"
              :skuId="skuId"
            ></QrAuthorize>
          </div>
        </div>
        <div v-else-if="this.processGraphic?.graphicItemMap?.data_authorize?.nodeStatus==2">
          <ReportGetting></ReportGetting>
        </div>
        <div v-else-if="this.processGraphic?.graphicItemMap?.data_authorize?.nodeStatus==3">
          <AuthorizeSuccessful></AuthorizeSuccessful>
        </div>
      </div>
      <!--数据正在采集提示页面-->
      <ReportGetting v-else-if="currentProcessCode=='data_authorize'&&isFinish" />
      <!--统计分析-->
      <div class="stateBox" v-else-if="currentProcessCode=='analyze'">
        <img src="@/assets/test/reportDefault.png" alt="">
        <span>报告生成中，请稍候…</span>
      </div>
      <!--报告已生成-->
      <div class="stateBox" v-else-if="currentProcessCode=='generate'">
        <img src="@/assets/test/reportSuccess.png" alt="">
        <span>报告已生成，请前往查看报告</span>
        <a-button type="primary" @click="tolog" style="margin-top: 30px;">查看报告</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import left from "./left.vue";
import right from "./right.vue";
import { isJSON } from "@/utils/helper.js"
import {
  getAuthToken,
  savePrepareFromSecond,
  savePrepare,
  getPrepareInfo,
  getSharedPrepareInfo, getProcessGraphicBySkuId, getTestingProcessGraphic, resetDataUpload
} from "@/api/openNew.js";

import { cloneDeep } from "lodash";
import DaliProgressV3 from "@/pages/openNew/component/DaliProgressV3.vue";
import HandleFinalSettlement from "@/pages/openNew/component/handleFinalSettlement.vue";
import { defineRemoteExpose } from "@/utils/remoteExpose";
import { getToken } from "@/utils/auth";
import RemoteComponent from "@/components/RemoteComponent.vue";
import ReportGetting from './component/reportGetting.vue'
import { finishDataUpload, hasUploadCheck} from "@/api/api";
import { getButtonShow } from '@/utils/permissionButton.js'
import { getPlatform } from "@/utils/device";
import MobileUploaderTip from "@/pages/openNew/MobileUploaderTip.vue";
import {message} from "ant-design-vue";
import QrAuthorize from "@/pages/openNew/QrAuthorize.vue";
import DataUploadedModal from "@/pages/openNew/component/DataUploadedModal.vue";
import AuthorizeSuccessful from "@/pages/components/AuthorizeSuccessful.vue";

const microServiceVue2 = process.env.VUE_APP_MICRO_SERVICE_VUE2;


export default {
  name: 'FetchService',
  components: {
    AuthorizeSuccessful,
    DataUploadedModal,
    QrAuthorize,
    MobileUploaderTip,
    RemoteComponent,
    HandleFinalSettlement,
    DaliProgressV3,
    left,
    right,
    ReportGetting
  },
  data () {
    return {
      hasScanQrcodeLogin:false, // 是否支持扫码登录
      creating: false,
      index: 1,
      fetchRemoteComponentRefSrc:'',
      maskLoading:false,
      companyInfo: {
        companyName: "",
        userName: "",
        userCode: "",
        password: "",
        identityType: 3,
        phoneNumber: "",
      },
      checkTimer: null,
      processGraphic: {},
      infos: {},
      validateMethod: 1, //验证方式 1密码 2验证码
      programId: "",
      isChecked: false,
      isDemo: undefined,
      currentProcessCode: '',
      isFinish: false,
      elementOperationCodes: [],
      canShowAuthProxy:false,
      canShowAuthLicenseAgreement:false,
      canShowAuthInvitation:false,
    };
  },
  computed: {
    offlineHandle(){
      return this.$route.query.offlineHandle==0?0:1;
    },
    skuId() {
      return this.$route.query.skuId
    },
    showCreateBtn() {
      const allowComponentsRouterName = ['manualTableList']
      return allowComponentsRouterName.includes(this.fetchRemoteComponentRefSrc)&&this.offlineHandle==1
    },
    token () {
      return getToken();
    },
    reportId () {
      return parseInt(this.$route.query.reportId.toString())
    },
    microServiceVue2 () {
      return microServiceVue2
    },
    appTypeName () {
      return this.$route.query.appTypeName
    },
    useElementOperation () {
      return this.$route.query.useElementOperation === '1' || this.$route.query.USE_ELEMENT_OPERATION === '1'
    }
  },
  beforeUnmount () {
    this.removeLister()
  },
  destroyed () {
    this.removeLister()
  },
  created () {
    this.initPermission()
  },
  async mounted () {
    defineRemoteExpose({
      receiveMsg: this.receiveMsg,
      checkAgreement: () => {
        this.isChecked = true;
      },
    })


    await this.exchangeToken(getToken());

    window.addEventListener("message", this.receiveMsg, false);
    //三方授权

    // if (this.$route.name == "oemGuardV4") {
    //   let accessToken = this.$route.query.accessToken;
    //   localStorage.setItem("accessToken", accessToken);
    //   //获取三方授权信息并保存
    //   await this.savePrepareApi();
    // } else if (this.$route.name == "oemGuardV4_3") {
    //   //如果是二方邀请页面则，从接口获取信息并保存在本地
    //
    //   const params = {
    //     uniqueCode: this.$route.query.uniqueCode,
    //   };
    //   const res = await getSharedPrepareInfo(params);
    //   if (res.status == 200) {
    //     localStorage.setItem(
    //       "share-accessToken",
    //       res.headers["share-accesstoken"]
    //     );
    //     if (res.data.code == 200) {
    //       this.infos = cloneDeep(res.data.data)
    //
    //       this.appTypeName = res.data.data.appTypeName;
    //       this.companyInfo.companyName = res.data.data.companyName;
    //       this.companyInfo.agentTaxNo = res.data.data.taxNo;
    //       this.companyInfo.userName = res.data.data.taxNo;
    //       this.programId = res.data.data.programId;
    //       this.validateMethod = res.data.data.validateMethod;
    //     }
    //   }
    // }

    if (this.$route.query.programId) {
      this.programId = this.$route.query.programId
    }
    await this.loadProcessGraphic()

    this.checkTimer = window.setInterval(() => {
      this.loadProcessGraphic()
    }, 5000);
    remoteEmit('remoteMounted', {})
    remoteEmit('dataAuthorizeChange',1)
  },
  methods: {
    getPlatform,
    async initPermission(){
      this.canShowAuthProxy = await getButtonShow('AUTH_PROXY')
      this.canShowAuthLicenseAgreement = await getButtonShow('AUTH_LICENSE_AGREEMENT')
      this.canShowAuthInvitation = await getButtonShow('AUTH_INVITATION')
    },
    handleDataUploadedModalUnlock(processGraphic){
      console.log("processGraphic",processGraphic)
      this.loadProcessGraphic()

    },

    openDataUploadedModalIfNeed(processGraphic){
      if (this.device=='mobile'){
        return
      }
      if (!['upload','data_authorize'].includes(this.currentProcessCode)){
        this.$refs['dataUploadedModalRef'].close()
        return false
      }

      if (processGraphic.graphicItemMap?.data_authorize==null){
        this.$refs['dataUploadedModalRef'].close()
        return false
      }

      if (processGraphic.graphicItemMap?.data_authorize.nodeStatus==3){
        this.$refs['dataUploadedModalRef'].close()
        return false
      }





      if (processGraphic.graphicItemMap?.upload?.nodeStatus==3&&this.currentProcessCode=='upload'){
        this.$refs['dataUploadedModalRef'].open(this.programId)
      }else{
        this.$refs['dataUploadedModalRef'].close()
      }
    },

    async isDataAuthorized(){
      if (this.processGraphic.graphicItemMap?.data_authorize==null){
        return true
      }
      await this.loadProcessGraphic()
      const ret =  this.processGraphic?.graphicItemMap?.data_authorize?.finish
      return ret
    },

    switchToUploadTabWhenAuthorizeAndUploadSupplied(){

      if(this.processGraphic?.graphicItemMap?.data_authorize&&this.processGraphic?.graphicItemMap?.upload){
        this.currentProcessCode='upload'
      }
    },
    handleFetchRemoteComponentRefVueRouterChange(params){

      params = JSON.parse(params)
      this.fetchRemoteComponentRefSrc = params.to?.name;
    },
    handleCancel(){
      console.log('cancel')
    },

    success () {
      this.$emit('success')
      //如果是土增或者企税项目，则需要跳转到自己的提交页面
      if (this.appTypeName == 'lvat' || this.appTypeName == 'eit') {
        this.submitSucces()
      }
      if (window.innerWidth < 750) {
        this.$router.replace({
          name: "oemGuardV4Success"
        })
        window.parent && window.parent.postMessage("v2-submit-success", "*");

        return
      }
        this.$router.push({
          name: "test-InvoiceUpload-oemV2",
          query: {
            from: this.appTypeName,
            redirect_uri: this.str && decodeURIComponent(this.str)

          }
        });
    },
    /*是否显示正在采集数据页面*/
    changeFinish (isFinish) {

      this.isFinish = this.processGraphic?.graphicItemMap?.data_authorize?.finish
    },
    /*生成报告*/
    async createReport () {
      // const isAuthorized = await this.isDataAuthorized()
      // if (!isAuthorized){
      //   message.warning('请先完成数据授权')
      //   return
      // }
      try {
        this.creating = true
        this.maskLoading=true
        const res = await hasUploadCheck({ programId: this.programId })

        if (res.data) {

          await this.doneOrPass()
          this.maskLoading = false
          //this.success()
        } else {
          message.warning(res.msgInfo || '请上传至少 1 个文件后再生成报告')
          this.creating = false
        }
      } catch (e) {
        this.creating = false
      }finally {
        this.creating = false
        setTimeout(()=>{
          this.maskLoading=false
        },5000)

      }

    },

    async doneOrPass () {
      console.log("doneOrPass")


      // const isAuthorized = await this.isDataAuthorized()
      // if (!isAuthorized){
      //   message.warning('请先完成数据授权')
      //   return
      // }



      const params = {
        programId: this.programId
      }
      const res = await finishDataUpload(params)
      if (res.code == 200) {
        this.changeFinish(true)

        const res = await getTestingProcessGraphic({
          programId: this.programId
        });

        this.openDataUploadedModalIfNeed(res.data)

        // this.currentProcessCode = res.data.currentItemCode


        //this.$refs['DaliProgressV3'].getState()
      }
    },


    handleLeftSuccess(){
      this.loadProcessGraphic()
      //this.switchToUploadTabWhenAuthorizeAndUploadSupplied()
    },



    async loadProcessGraphic () {
      const res = await getTestingProcessGraphic({
        programId: this.programId
      });
      const processGraphic = cloneDeep(res.data)
      this.processGraphic = processGraphic
      this.hasScanQrcodeLogin = res.data.hasScanQrcodeLogin

      this.openDataUploadedModalIfNeed(res.data)

      if (!(['data_authorize', 'upload'].includes(this.currentProcessCode) && ['data_authorize', 'upload'].includes(this.processGraphic.currentItemCode))) {
        this.currentProcessCode = this.processGraphic.currentItemCode
      }else if (!['data_authorize', 'upload'].includes(this.processGraphic.currentItemCode)){
        this.currentProcessCode = this.processGraphic.currentItemCode
      }

    },
    removeLister () {
      clearInterval(this.checkTimer)
    },
    async handleChooseAbility (code) {
      console.log('handleChooseAbility')
      // const processGraphic = cloneDeep(this.processGraphic)
      // processGraphic.currentItemCode = code
      // this.processGraphic = processGraphic
      this.currentProcessCode = code
      const res = await getTestingProcessGraphic({
        programId: this.programId
      });
      this.openDataUploadedModalIfNeed(res.data)
    },
    async savePrepareApi () {
      // this.str = encodeURIComponent(this.$route.query.redirect_uri)
      this.str = this.$route.query.redirect_uri
      const params = {
        state: this.$route.query.state,
        skuId: this.$route.query.skuId,
        redirectUri: decodeURIComponent(this.str)
        // redirectUri:decodeURIComponent(this.$route.query.redirect_uri)
      }
      const res = await savePrepare(params)
      if (res.code == 200) {
        this.programId = res.data.programId
      }

    },
    async saveCompanny (e) {
      console.log('saveCompanny')

      const params = {
        programId: e.programId || '',
        taxNo: e.companyNo,
        companyName: e.companyName,
        startDate: e.startYear,
        endDate: e.endYear,
        appTypeName: this.appTypeName,
        remainDays: e.remainDays ? e.remainDays : ''
      }
      if (this.appTypeName == 'lvat' || this.appTypeName == 'eit') {
        params.state = JSON.stringify({ projectId: this.getInfo.projectId || '' })
      }
      const res = await savePrepareFromSecond(params)
      if (res.code == 200) {
        this.programId = res.data.programId
        const params = {
          messageInfo: 'setProgramId',
          value: this.programId
        }
        window.parent && window.parent.postMessage(JSON.stringify(params), "*");

      }

    },
    async exchangeToken (e) {
      const params = {
        appTypeName: this.appTypeName,
        authorization: e,
      };
      const res = await getAuthToken(params);
      if (res.code == 200) {
        localStorage.setItem("accessToken", res.data.accessToken);
      }
    },
    async receiveMsg (data, isfirst = true) {
      if (isJSON(data)) {
        let info = JSON.parse(data);

        if (info.messageInfo == "setMessage") {

          if (isfirst) {
            this.infos = cloneDeep(info)

          }
          this.getInfo = info;
          this.companyInfo.companyName = info.companyName;
          this.programId = info.programId || this.programId;
          this.isDemo = info.isDemo || false;
          if (this.index == 1) {
            this.companyInfo.userName = info.companyNo;
            delete this.companyInfo.agentTaxNo
          } else {
            this.companyInfo.agentTaxNo = info.companyNo;
            this.companyInfo.userName = '';
          }

          if (isfirst) {
            await this.saveCompanny(info);
          }

          const res = await getPrepareInfo({ programId: this.programId });
          if (res.code == 200) {
            this.validateMethod = res.data.validateMethod;
          }

        }
      }
    },
    changeType (e) {
      if (!this.canShowAuthProxy && e === 2) {
        return
      }
      this.index = e;
      if (this.$route.name == "oemGuardV4") {
        this.companyInfo = {
          companyName: "",
          userName: "",
          userCode: "",
          password: "",
          identityType: 3,
          phoneNumber: "",
        }

        this.$refs.leftRef.validateMethod = 1
        this.$refs.leftRef.isChecked = false
        this.$refs.rightRef.validateMethod = 1
        this.$refs.rightRef.isChecked = false
      } else if (this.$route.name == "oemGuardV4_3") {
        if (e == 1) {
          this.companyInfo.userName = this.infos.taxNo;
        } else {
          this.companyInfo.userName = '';
        }
      }
      this.receiveMsg( JSON.stringify(this.infos) , false)
      remoteEmit('dataAuthorizeChange',e)

    },
    tolog () {
      //新窗口打开生成报告
      remoteEmit('toLog', {})


    },
  },
};
</script>
<style scoped lang="stylus">
.stateBox {
  margin-top: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 120px;
    height: 120px;
    margin-bottom: 30px;
  }
  span {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #0E1429;
  }
}
.topselect {
  margin-top: 16px;
  padding: 0rem;
  display: flex;
  border-bottom 1px solid #E6E8EA;
  > div {
    padding 10px 12px;
    cursor: pointer;
    font-family: PingFang SC;
    color: #1d2129;
    font-weight: 400;
    font-size: 14px;
    padding-bottom: 6.5px;
  }
  div.active {
    color: #165dff;
    font-weight: bold;
    border-bottom: 2px solid #165dff;
  }
}
@media screen and (max-width: 768px) {
  .topselect {
    padding 0 .3rem
    border-bottom: 0 none;
    box-sizing: border-box;
    margin-top: .2rem;
    > div:first-child {
      border-radius: 4px 0px 0px 4px;
    }
    > div:last-child {
      border-radius: 0 4px 4px 0px;
    }
    > div {
      border-radius 0
      text-align: center;
      border: 1px solid #dfdfe0;
      width: 50%;
      height: .64rem;
      line-height: 1.5;
      padding 0
      display flex;
      align-items center;
      justify-content: center;
    }
    > div.active {
      border: 0;
      line-height: 1;
      color: white;
      background-color: #165dff;
      font-weight: 400;
    }
  }
}
.create-report-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0
}
.device-mobile {
  .dali-progress-wrapper {
    padding .2rem .3rem;
    padding-bottom 0
  }
}
</style>
